import React from 'react';
import {
  Box,
  Typography,
  Tooltip,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon, Info as InfoIcon } from '@mui/icons-material';

const VariableSelector = ({ 
  variableCategories, 
  onInsertVariable, 
  showVariables, 
  onToggleVariables 
}) => {
  return (
    <Box>
      <Button
        variant="text"
        onClick={onToggleVariables}
        startIcon={<ExpandMoreIcon sx={{ 
          transform: showVariables ? 'rotate(180deg)' : 'none',
          transition: 'transform 0.3s'
        }} />}
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 1,
          mb: showVariables ? 2 : 0
        }}
      >
        <Typography variant="subtitle2">
          Add Message Variables
        </Typography>
        <Tooltip title="Click on a variable to insert it into your message">
          <InfoIcon fontSize="small" />
        </Tooltip>
      </Button>
      {showVariables && (
        <Box sx={{ mt: 1 }}>
          {variableCategories.map((category) => (
            <Accordion key={category.name}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`${category.name}-content`}
                id={`${category.name}-header`}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="subtitle2">
                    {category.name}
                  </Typography>
                  <Tooltip title={category.description}>
                    <InfoIcon fontSize="small" color="action" />
                  </Tooltip>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {category.variables.map((variable) => (
                    <Tooltip 
                      key={variable.name} 
                      title={
                        <Box>
                          <Typography variant="body2">{variable.description}</Typography>
                          <Typography variant="caption" color="text.secondary">
                            Field: {variable.field_name}
                          </Typography>
                        </Box>
                      }
                    >
                      <Chip
                        label={`{{${category.name}.${variable.name}}}`}
                        size="small"
                        onClick={() => onInsertVariable(category.name, variable.name)}
                        sx={{ 
                          '&:hover': {
                            backgroundColor: 'primary.light',
                            color: 'primary.contrastText'
                          }
                        }}
                      />
                    </Tooltip>
                  ))}
                </Box>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default VariableSelector; 